























































import { IChannel } from "@/@types/channels/channels";
import { Component, Prop, Inject, Vue } from "vue-property-decorator";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartTable from "@/components/tables/standart-table.vue";

interface ISortColumn {
  name: number;
  channelType: number;
  show: number;
  sort_order: number;
}

@Component({ components: { BSwitch, StandartTable } })
export default class IpStreamChannels extends Vue {
  @Prop({ type: Array, default: () => [] }) channels!: Array<IChannel>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: String, default: "" }) sortKey!: string;
  @Prop({ type: Object, default: null }) sortOrder!: ISortColumn;

  @Inject() readonly channel_images!: string;

  channel_id = "";

  get channel(): IChannel | null {
    const channel = this.channels.find((ch) => ch._id == this.channel_id);
    return channel ? channel : null;
  }
}
